import { useState } from 'react';

import classes from './Modal.module.scss';

const CategoryModal = ({ categories, transaction, onCategoryChange, onClose }) => {
  const [category, setCategory] = useState(transaction.category?.id);

  const handleSubmit = (event) => {
    event.preventDefault();
    onCategoryChange(transaction.id, category);
    onClose();
  };

  return (
    <div className={classes.overlay}>
      <form
        onSubmit={(event) => {
          event.persist();
          handleSubmit(event);
        }}
      >
        <label className={classes.label}>
          <span>Categoria</span>
          <select
            type="text"
            name="category"
            required
            value={category}
            onChange={(e) => {
              setCategory(e.target.value);
            }}
          >
            <option value="0">❔ Sem categoria</option>
            {categories.map((category) => (
              <option value={category.id} key={category.id}>
                {category.emoji} {category.title}
              </option>
            ))}
          </select>
        </label>
        <button className={classes.submit}>
          Gravar
        </button>
        <button
          className={classes.submit}
          type="button"
          onClick={onClose}
        >
          Cancelar
        </button>
      </form>
    </div>
  );
};

export default CategoryModal;
